import { Tag } from "@/ui";
import { FLOAT_STATUS } from "@lib/enums";

const STATUS_COLORS = {
  [FLOAT_STATUS.DRAFT]: "neutral",
  [FLOAT_STATUS.PUBLISHED]: "primary",
  [FLOAT_STATUS.SENT]: "success",
  [FLOAT_STATUS.ARCHIVED]: "warning",
};

export default function StatusChip({ status }) {
  const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : "";

  return <Tag color={STATUS_COLORS[status] ?? "neutral"}>{label}</Tag>;
}
